// features/salary/salarySlice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { calculateGrossSalaryApi, calculateamountSalary, calculateNetSalaryApi } from './salary.service';

export const fetchAmount = createAsyncThunk(
  'salary/fetchSalary',
  async (payload: any) => {
    const data = await calculateamountSalary(payload);
    return data;
  }
);
export const fetchGrossAmount = createAsyncThunk(
  'salary/fetchGrossAmount',
  async (payload: any) => {
    const data = await calculateGrossSalaryApi(payload);
    return data;
  }
);

export const fetchNetSalary = createAsyncThunk(
  'salary/fetchNetSalary',
  async (payload: any) => {
    const data = await calculateNetSalaryApi(payload);
    return data;
  }
);

type Awaited<T> = T extends Promise<infer U> ? U : T;

type SalaryState = {
  message: string | null;
  invoiceData: Awaited<ReturnType<typeof calculateamountSalary>> | null;
  grossData: Awaited<ReturnType<typeof calculateGrossSalaryApi>> | null;
  netData: Awaited<ReturnType<typeof calculateNetSalaryApi>> | null;
  loading: boolean;
  error: string | null;
};

const initialState: SalaryState = {
  message: null,
  invoiceData: 0,
  grossData: 0,
  netData: 0,
  loading: false,
  error: null,
};

const salarySlice = createSlice({
  name: 'salary',
  initialState,
  reducers: {
    clearSalaryData: (state) => {
      state.invoiceData = null;
      state.grossData = null;
      state.netData = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchAmount.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAmount.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload as any;
        state.invoiceData = payload.response;
      })
      .addCase(fetchAmount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Something went wrong';
      })
      
      .addCase(fetchGrossAmount.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGrossAmount.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload as any;
        state.grossData = payload.response;
      })
      .addCase(fetchGrossAmount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Something went wrong';
      })
      
      .addCase(fetchNetSalary.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNetSalary.fulfilled, (state, action) => {
        state.loading = false;
        const payload = action.payload as any;
        state.netData = payload.response;
      })
      .addCase(fetchNetSalary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Something went wrong';
      });
  },
});

export const { clearSalaryData } = salarySlice.actions;
export default salarySlice.reducer;
